let windowUtils = {
    screenOrientation: window.screen.orientation || window,
    changeOrientationEvent: window.screen.orientation ? 'change' : 'orientationchange',
    orientationListeners: [],
    lastOrientation: null,
    resizeTimeout: null,
    
    addOrientationListener: function(callback) {
        // Store the callback in our array for potential cleanup
        this.orientationListeners.push(callback);
        
        // Initialize lastOrientation if this is the first listener
        if (this.lastOrientation === null) {
            this.lastOrientation = this.getOrientation();
            
            // Set up the primary orientation event listener (once)
            if (this.orientationListeners.length === 1) {
                this.screenOrientation.addEventListener(this.changeOrientationEvent, this._handleOrientationChange.bind(this), {passive: true});
                
                // Set up the backup resize listener (once)
                // this is for browsers such as Safari
                window.addEventListener('resize', this._handleResize.bind(this), {passive: true});
            }
        }
        
        return callback; // Return the callback for reference when removing
    },

    removeOrientationListener: function(callback) {
        // Find and remove the callback from our array
        const index = this.orientationListeners.indexOf(callback);
        if (index !== -1) {
            this.orientationListeners.splice(index, 1);
        }
        
        // If no more listeners, remove the global event handlers
        if (this.orientationListeners.length === 0) {
            this.screenOrientation.removeEventListener(this.changeOrientationEvent, this._handleOrientationChange.bind(this));
            window.removeEventListener('resize', this._handleResize.bind(this));
            this.lastOrientation = null;
        }
    },
    
    // Private method to handle orientation change events
    _handleOrientationChange: function(event) {
        // Call all registered callbacks
        this.orientationListeners.forEach(callback => {
            try {
                // Check if callback is a function before calling it
                if (typeof callback === 'function') {
                    callback(event);
                } else {
                    console.warn('Orientation change callback is not a function:', callback);
                }
            } catch (e) {
                console.error('Error in orientation change callback:', e);
            }
        });
        
        // Update last orientation
        this.lastOrientation = this.getOrientation();
    },
    
    // Private method to handle resize events as a backup for orientation changes (namely Safari browser)
    _handleResize: function(event) {
        // Clear any existing timeout to debounce resize events
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        
        // Set a timeout to avoid excessive calls during resize
        this.resizeTimeout = setTimeout(() => {
            const currentOrientation = this.getOrientation();
            if (currentOrientation !== this.lastOrientation) {
                this.lastOrientation = currentOrientation;
                this._handleOrientationChange(event);
            }
        }, 150); // Debounce time in ms
    },
    
    getOrientation: function() {
        // Return 'portrait' or 'landscape' based on screen dimensions
        return window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
    },
    
    isPortrait: function() {
        return this.getOrientation() === 'portrait';
    },
    
    isLandscape: function() {
        return this.getOrientation() === 'landscape';
    }
};

// Automatically clean up orientation listeners on page unload (when switching pages)
window.addEventListener('beforeunload', () => {
    // Remove all orientation listeners
    // Copy the array to avoid mutation issues during iteration
    windowUtils.orientationListeners.slice().forEach(cb => {
        windowUtils.removeOrientationListener(cb);
    });
});